<div class="addNewPolicyContainer">
        <div id="loading-container" style="padding:18% 50%;" *ngIf="isShowLoading==true" >
                <img id="lodergifImg" src="../../assets/img/loadergif.gif" alt="Loading..." style="width:44px;" />
             </div>


    <div class="Clears"></div>
</div>


<div class="container-fluid">
    <div class="MyProposalForm disForm seoLandingPage">
        <div class="col-lg-5 col-md-5 hidden-sm hidden-xs">
            <div class="car_bg">

                <div class="Description">
                    <h3>{{'Motor Insurance'|translate}}</h3>
                    <span>Compare plans from 15+ insurers & save up to 60%</span>

                    <ul>
                        <li>25 lakh+ vehicles insured</li>
                        <li>Insta-Claims, exclusively for Policybazaar customers</li>
                        <li>1500+ advisors, FREE 365 Day Support</li>
                        <li>Awarded India's #1 financial website</li>
                        <li>25 lakh+ vehicles insured</li>
                        <li>Insta-Claims, exclusively for Policybazaar customers</li>
                        <li>1500+ advisors, FREE 365 Day Support</li>
                        <li>Awarded India's #1 financial website</li>
                    </ul>
                </div>
                <i class="fa fa-angle-right arrows"></i>
            </div>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
            <form #NewPolicyForm="ngForm">
                <div class="CarForm">
                    <div class="InsuredInformation Infomation">

                        <div class="FormSection">

                            <div class="Clears"></div>


                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label>{{'Vehicle Definition Type'|translate}}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <select class="form-control" id="txtVDT" name="txtVDT" required [(ngModel)]="newPolicyReq.VDT">
                                            <option value="2">{{'Sequence No'|translate}}</option>
                                            <option value="3">{{'Customer Id'|translate}}</option>

                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label>{{'Iqama No'|translate}}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" required id="txtIqmaNo" name="txtIqamaNo"   type="text" [(ngModel)]="newPolicyReq.IqamaNo"
                                            [disabled]="true">


                                    </div>
                                </div>
                            </div>




                            <div class="Field" *ngIf="newPolicyReq.VDT=='2'">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label>{{'Sequence No'|translate}}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" minlength="6" maxlength="9" [required]="newPolicyReq.VDT==2" pattern="^[1-9][0-9]{5,8}$" placeholder="Sequence No" type="text"
                                            id= "txtSeqNo" name="txtSeqNo" [(ngModel)]="newPolicyReq.SequenceNo" #txtSeqNo="ngModel">
                                        <span *ngIf="txtSeqNo.errors && (txtSeqNo.dirty || txtSeqNo.touched)">
                                            <p *ngIf="txtSeqNo.errors?.required">{{'Sequence No is required'|translate}}</p>
                                            <p *ngIf="txtSeqNo.errors?.pattern && txtSeqNo.invalid && txtSeqNo.touched">{{'Sequence No must be 6 to 9 digits and not start with Zero'|translate}} </p>
                                        </span>

                                    </div>
                                </div>
                            </div>



                            <div class="Field" *ngIf="newPolicyReq.VDT=='3'">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label>{{'Customer Id'|translate}}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" maxlength="10" minlength="10" [required]="newPolicyReq.VDT==3" pattern="^[1-9][0-9]{9}$" placeholder="Customer Id"
                                            type="text" id="txtCustomID" name="txtCustomID" [(ngModel)]="newPolicyReq.CustomID" #txtCustomID="ngModel">
                                        <span *ngIf="txtCustomID.errors && (txtCustomID.dirty || txtCustomID.touched)">
                                            <p *ngIf="txtCustomID.errors?.required">{{'Custom ID is required'|translate}}</p>
                                            <p *ngIf="txtCustomID.errors?.pattern && txtCustomID.invalid && txtCustomID.touched">{{'CustomID must be 10 digits and not start with Zero'|translate}} </p>
                                        </span>

                                    </div>
                                </div>
                            </div>

                            <div class="Field" class="Field" *ngIf="newPolicyReq.VDT=='3'">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label>{{'Custom ID Issuence Date'|translate}}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" maxlength="10" minlength="10" [required]="newPolicyReq.VDT==3" name="txtCustDate" id="txtCustDate"
                                            placeholder="Custom ID Issuence Date" pattern="^([1-9]|(0|1|2)[0-9]|30)(/|-)([1-9]|1[0-2]|0[1-9])(/|-)((13|14|15)[0-9]{2})$"
                                            type="text" [(ngModel)]="newPolicyReq.CustomIssuenceDate" #txtCustDate="ngModel">
                                        <span *ngIf="txtCustDate.errors && (txtCustDate.dirty || txtCustDate.touched)">
                                            <p *ngIf="txtCustDate.errors?.required">{{'Custom ID Issuence Date is required'|translate}}</p>
                                            <p *ngIf="txtCustDate.errors?.pattern && txtCustDate.invalid && txtCustDate.touched">{{'Invalid Hijri Date(dd/MM/yyyy)'|translate}}</p>
                                        </span>

                                    </div>
                                </div>
                            </div>

                            



                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <label class="transfer">
                                            <input type="checkbox" id="txtTOS" name="txtTOS" [(ngModel)]="newPolicyReq.isTransferOfShip" />{{'Transfer of OwnerShip'|translate}}</label>


                                    </div>
                                </div>
                            </div>

                            <div class="Field" *ngIf="newPolicyReq.isTransferOfShip">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label>{{'Owner Iqama No'|translate}}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" pattern="^[1234][0-9]{9}$" minlength="10" maxlength="10" [required]="newPolicyReq.isTransferOfShip" id="txtOwnerIqamaNo" name="txtOwnerIqamaNo" placeholder="Owner Iqama No" type="text" [(ngModel)]="newPolicyReq.OwnerIqamaNo" #txtOwnerIqamaNo="ngModel">
                                        <span *ngIf="txtOwnerIqamaNo.errors && (txtOwnerIqamaNo.dirty || txtOwnerIqamaNo.touched)">
                                                <p *ngIf="txtOwnerIqamaNo.errors?.required">{{'Owner Iqama No is required'|translate}}</p>
                                                <p *ngIf="txtOwnerIqamaNo.errors?.pattern && txtOwnerIqamaNo.invalid && txtOwnerIqamaNo.touched">{{'Iqama No Must start with 1 or 2 or 3 or 4 and It must be 10 digits'|translate}} </p>
                                            </span>

                                    </div>
                                </div>
                            </div>
                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label>{{'Do you have promo code?'|translate}}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <!-- <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10"> -->
                                        <input class="form-control" id="txtPromo" id="txtPromo" placeholder="Promo Code" type="text" [(ngModel)]="newPolicyReq.PromoCode">
                                        <!-- </div> -->
                                        <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2" style="padding-left:0px;">
                                                             <button class="btn btn-primary btns" style="float:left;">Apply</button>
                                                             </div> -->


                                    </div>
                                </div>
                            </div>



                        </div>






                        <!-- Button Actions -->

                        <div class="Actionsection">
                            <div class="Actions">
                                <div class="btn-group">

                                    <button type="button" name="txtBUY" id="txtBUY" class="btn btn-primary btns" [disabled]="!NewPolicyForm.valid" (click)="BUYPolicy()">{{'Buy'|translate}}</button>

                                </div>
                            </div>
                        </div>
                        <div class="Clears"></div>

                    </div>
                </div>
            </form>
        </div>


    </div>
</div>

<div class="PayMethods">
    <img src="assets/img/payment-footer-en.png">
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/ProposalForm/ProposalForm.html